import { render } from "./IconUser.vue.js?vue&type=template&id=0c9c3a92!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconUser.vue?vue&type=template&id=0c9c3a92"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__